import type { ReactNode } from 'react';
import Icon, { type IconName } from './Icon';

interface Props {
  /** El glifo del degradado lila→mint. Por defecto, la bandeja. */
  icon?: IconName;
  title: string;
  /** Una frase: qué falta, o qué va a pasar solo. */
  note?: ReactNode;
  /** La puerta, cuando el vacío tiene una. */
  action?: ReactNode;
}

/**
 * El estado vacío de la casa, calcado de `.board__empty` de tbit-canvas.
 *
 * Un vacío no es un error y no se escribe como tal: es un marco punteado —no un
 * borde sólido, que leería como una tarjeta rota— con el arte de marca, una
 * frase de qué falta y, si existe, la puerta. Antes de esto cada pantalla
 * resolvía su vacío con un `<p class="text-base-content/50">` distinto.
 */
export default function EmptyState({ icon = 'inbox', title, note, action }: Props) {
  return (
    <div className="empty">
      <div className="empty__art">
        <Icon name={icon} size={26} />
      </div>
      <strong className="empty__title">{title}</strong>
      {note && <span className="empty__note">{note}</span>}
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}
